module.exports = new __parcel__URL__("lpb.a7a899ad.png").toString();